import { render, staticRenderFns } from "./F2FDetailTable.vue?vue&type=template&id=68a9acab"
import script from "./F2FDetailTable.vue?vue&type=script&lang=js"
export * from "./F2FDetailTable.vue?vue&type=script&lang=js"
import style0 from "./F2FDetailTable.vue?vue&type=style&index=0&id=68a9acab&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports